<template>
  <AppModal
    v-model="showModal"
    title="Unsaved Changes"
    @update:model-value="onCloseModal"
  >
    <template #body>
      <p>
        Would you like to save the changes you made before navigating away from
        this page?
      </p>
    </template>
    <template #footer>
      <AppButton
        expanded
        class="mr-auto"
        theme="secondary"
        :disabled="unsavedChangesStore.isLoading"
        @click="handleDiscard"
      >
        Discard
      </AppButton>
      <AppButton
        expanded
        theme="tertiary"
        :disabled="unsavedChangesStore.isLoading"
        @click="handleCancel"
      >
        Cancel
      </AppButton>
      <AppButton
        expanded
        theme="labour"
        :disabled="unsavedChangesStore.isLoading"
        @click="handleSave"
      >
        <span class="inline-flex items-center">
          Save Changes
          <AppSpinner v-if="unsavedChangesStore.isLoading" />
        </span>
      </AppButton>
    </template>
  </AppModal>
</template>

<script setup>
import { computed } from 'vue'
import { useUnsavedChangesStore } from '../../stores/unsavedChangesStore.js'

const unsavedChangesStore = useUnsavedChangesStore()

const showModal = computed({
  get: () =>
    !!unsavedChangesStore.pendingNavigation ||
    !!unsavedChangesStore.pendingCallback,
  set: (value) => {
    if (!value) unsavedChangesStore.handleCancel()
  },
})

const handleSave = () => unsavedChangesStore.handleSave()
const handleDiscard = () => unsavedChangesStore.handleDiscard()
const handleCancel = () => unsavedChangesStore.handleCancel()
const onCloseModal = (value) => {
  if (!value) handleCancel()
}
</script>
